<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex>
          <h1 class="mb-3">
            Knowledge Base
            <b>({{ bot.botTitle }})</b>
          </h1>
        </v-flex>
        <add-knowledge
          v-if="common.hasPermissions('llm', ['create'])"
          :botId="bot.botId"
          @created="() => setTimeout(() => getList(), 3000)"
        ></add-knowledge>
        <update-knowledge
          v-if="common.hasPermissions('llm', ['update']) && item"
          :botId="bot.botId"
          :data="item"
          :showDialog="showEdit"
          @close="(v) => (showEdit = v)"
          @submitted="() => getList()"
        ></update-knowledge>
        <v-dialog v-model="deleteDialog" width="500">
          <delete-dialog
            :title="`${item.name}`"
            @onDelete="deleteItem(item)"
            @closeDialog="deleteDialog = false"
          ></delete-dialog>
        </v-dialog>
      </v-layout>
      <v-card class="rounded-box" flat>
        <v-card-title class="pt-0 px-0">
          <v-text-field
            v-model="search"
            append-icon="search"
            class="ma-0 pa-0"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <!-- <v-spacer></v-spacer>
                    <v-layout justify-space-between align-center>
                    <div class="px-3">Filter by Status</div>
                    <v-select
                        v-model="filter.status"
                        :items="['all', 'pending', 'approved', 'rejected', 'blocked']"
                        label="Status"
                        class="ma-0 pa-0"
                        single-line
                        hide-details
                        @change="getUsers"
                    ></v-select>
                    </v-layout> -->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :rows-per-page-items="[
            10,
            25,
            { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
          ]"
        >
          <template v-slot:items="{ item }">
            <!-- <td>{{ item.uuid }}</td> -->
            <td>{{ item.name }}</td>
            <td>
              <v-chip
                small
                :color="statusColors[item.status]"
                text-color="white"
                >{{ item.status }}</v-chip
              >
            </td>
            <td
              v-if="
                common.hasPermissions('llm', ['update']) ||
                common.hasPermissions('llm', ['delete'])
              "
            >
              <v-layout row wrap justify-center>
                <v-icon
                  v-if="common.hasPermissions('llm', ['update'])"
                  small
                  class="mr-2"
                  @click="edit(item)"
                  >mdi-pencil</v-icon
                >
                <v-icon
                  v-if="common.hasPermissions('llm', ['delete'])"
                  small
                  @click="openDeleteDialog(item)"
                  >mdi-delete</v-icon
                >
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import deleteDialog from "../../components/common/deleteDialog";
import common from "../../utils/common";
import addKnowledge from "./apps/AddKnowledge";
import updateKnowledge from "./apps/UpdateKnowledge";
export default {
  name: "knowledge-base",
  components: {
    addKnowledge,
    updateKnowledge,
    deleteDialog,
  },
  data() {
    return {
      common,
      search: "",
      filter: {
        status: "all",
      },
      showEdit: false,
      deleteDialog: false,
      // accountID: "",
      statusColors: {
        active: "green",
        pending: "orange",
        failed: "red",
      },
      item: {},
    };
  },
  async mounted() {
    await this.getList();
  },
  computed: {
    bot() {
      return this.$store.state.bot;
    },
    list() {
      return this.$store.getters["llm/knowledge/get"];
    },

    headers() {
      return [
        // { text: "UUID", value: "uuid" },
        { text: "Name", value: "name" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "action", align: "center" },
      ];
    },
  },
  methods: {
    async getList() {
      await this.$store.dispatch("llm/knowledge/get", {
        botID: this.bot.botId,
      });
    },
    edit(item) {
      this.item = item;
      console.log(item, "item");
      this.showEdit = true;
    },
    openDeleteDialog(item) {
      this.item = item;
      this.deleteDialog = true;
    },
    async deleteItem(item) {
      await this.$store.dispatch("llm/knowledge/delete", {
        botID: this.bot.botId,
        id: item.uuid,
      });

      this.deleteDialog = false;
    },
  },
};
</script>
